import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsProductsSdconfigRoute: InvariantJiraRoute = {
	name: 'global-settings-products-sdconfig',
	path: '/secure/admin/SDConfiguration.jspa',
};
